// @flow
/* eslint-disable max-len */

import { defineMessages } from 'react-intl';

export default defineMessages({
    loginAccountLocked: {
        id: 'application.account-locked',
        defaultMessage:
            'Sorry, one too many login attempts have locked your account. Click on the <a href="/forgotten-password">forgotten password</a> link to unlock it and reset your password.',
        linkHref: '/forgotten-password',
        linkText: 'Reset your password?'
    },
    loginNotAuthorized: {
        id: 'application.not-authorized',
        defaultMessage:
            'Sorry, we can\'t find these login details. Please check and try again. <a href="https://www.hivehome.com/cant-find-details">Need help?</a>',
        linkHref: 'https://www.hivehome.com/cant-find-details',
        linkText: 'Need help?'
    },
    loginUnexpectedError: {
        id: 'application.login-unexpected-error',
        defaultMessage: 'There was an unexpected error logging into your account.'
    },
    hiveLinkUnsupported: {
        id: 'application.login-hive-link-unsupported-error',
        defaultMessage: 'Hive Link will be coming to the web soon...'
    }
});



// WEBPACK FOOTER //
// ./src/core/state/application/intl.js